document.addEventListener('DOMContentLoaded', function() {
    const recommended_popup = document.querySelector('.recommended-popup');
    if (recommended_popup) {
        setTimeout(() => {
            recommended_popup.classList.add('fadeIn');
            document.body.style.overflow = 'hidden';
        }, 1500);

        const close = recommended_popup.querySelector('.recommended-popup__close');
        if (close) {
            close.addEventListener('click', () => {
                recommended_popup.classList.add('fadeOut');
                recommended_popup.classList.remove('fadeIn');
                document.body.style.overflow = 'unset';
            });
        }

        const recommended_swiper = new Swiper('.recommended-popup__swiper', {
            slidesPerView: 3,
            grabCursor: false,
            spaceBetween: 50,
            autoHeight: false,
            preloadImages: true,
            loop: false,
            createElements: false,
            lazy: true,
            breakpoints: {
                0: { // when window >=0px - webflow mobile portrait
                    slidesPerView: 1,
                    spaceBetween: 15,
                    loop: true,
                },
                768: { // when window >= 767px - webflow tablet
                    slidesPerView: 3,
                    spaceBetween: 15,
                    loop: false,
                },
                992: { // when window >= 988px - webflow desktop
                    slidesPerView: 3,
                    spaceBetween: 30,
                    loop: false,
                },
                1920: { // when window >= 1920px - webflow desktop
                    slidesPerView: 3,
                    spaceBetween: 30,
                    loop: false,
                }
            },
            navigation: {
                nextEl: '.recommended-popup__cards-next',
                prevEl: '.recommended-popup__cards-prev',
            },
            pagination: false,
            autoplay: false,
            speed: 300,
        });
    }
});
